<template>
  <div class="grey darken-1 empty-layout">
    <router-view />
  </div>
</template>
<script>
import messages from '@/utils/messages'
import localizeFilter from '@/filters/localize.filter'
export default {
  computed:{
    error(){
      return this.$store.getters.error
    },
    locale() {
      return this.$store.getters.info.locale
    }
  },
  watch: {
    error(fbError){
      //console.log('Firebase Error',fbError)
      this.$error(messages[fbError.code] || localizeFilter('Something_Wrong'))
      //console.log(messages)
    }
  }
}
</script>
